import { uuid } from '../../CodesThatsGottaGoSomewhereElse';

const memoStoreProp = Symbol('CacheStore');

const isEqual = ((a: any[], b: any[]) => {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
});

export interface MemoStore {
    getIfHit(key: string, source: any[]): any;
    set(key: string, source: any[], value: any): void;
    clear(): void;
}

class MemoStoreImpl {
    private store = new Map<string, [any[], any]>();

    getIfHit(key: string, source: any[]): any {
        if (this.store.has(key)) {
            const [lastSource, lastResult] = this.store.get(key);
            if (isEqual(source, lastSource)) {
                return lastResult;
            }
        }
    }

    set(key: string, source: any[], result: any) {
        this.store.set(key, [source, result]);
    }

    clear() {
        this.store.clear();
    }

}

export const MemoStore = {
    get(obj: any): MemoStore {
        return obj[memoStoreProp] ?? (obj[memoStoreProp] = new MemoStoreImpl());
    },
    getMaybe(obj: any): MemoStore | null {
        return obj[memoStoreProp] || null;
    },
    clear(obj: any) {
        obj[memoStoreProp]?.clear();
    }
};

export const MemoKey = {
    create(name: string) {
        return `${name}-${uuid().split('-')[0]}`;
    }
};
